import styled from 'styled-components';
import { asRem } from 'utils';
import { Container } from 'Common';

export default styled(Container)`
  padding-top: ${asRem(16)};

  .library-app-ad-tile__wrapper {
    padding-top: ${asRem(24)};
  }

  .app-ad-tile {
    display: flex;
    gap: ${asRem(16)};
    flex-direction: row;
    justify-content: center;
    margin-top: ${asRem(12)};
  }
`;
